import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app.js'
import './index.css'
import { BrowserRouter, Routes, HashRouter } from 'react-router-dom'
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <HashRouter>
    <App />
  </HashRouter>
)
